import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="terms">
      <Header />

      <main className="terms__main">
        {/* 面包屑导航 */}
        <div className="breadcrumb">
          <div className="breadcrumb__container">
            <Link to="/" onClick={toTop}>
              HOME
            </Link>
            <span className="breadcrumb__separator">»</span>
            <span className="breadcrumb__current">TERMS & CONDITIONS</span>
          </div>
        </div>

        <div className="terms__container">
          <div className="terms__content">
            {/* 页面标题 */}
            <section className="terms__hero">
              <h1 className="terms__title">TERMS & CONDITIONS</h1>
              <p className="terms__subtitle">
                Please read these terms and conditions carefully before using
                our services
              </p>
              <p className="terms__updated">Last updated: January 2025</p>
            </section>

            {/* 条款内容 */}
            <div className="terms__sections">
              <section className="terms__section">
                <h2 className="section__title">1. Agreement to Terms</h2>
                <div className="section__content">
                  <p className="section__text">
                    By accessing and using the Emeline Publications website, you
                    accept and agree to be bound by the terms and provision of
                    this agreement. These Terms and Conditions apply to all
                    visitors, users, and others who access or use our service.
                  </p>
                  <p className="section__text">
                    If you do not agree to abide by the above, please do not use
                    this service. We reserve the right to change these terms at
                    any time without prior notice.
                  </p>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">2. Use License</h2>
                <div className="section__content">
                  <p className="section__text">
                    Permission is granted to temporarily download one copy of
                    the materials on Emeline Publications' website for personal,
                    non-commercial transitory viewing only. This is the grant of
                    a license, not a transfer of title, and under this license
                    you may not:
                  </p>
                  <ul className="section__list">
                    <li>Modify or copy the materials</li>
                    <li>
                      Use the materials for any commercial purpose or for any
                      public display
                    </li>
                    <li>
                      Attempt to reverse engineer any software contained on the
                      website
                    </li>
                    <li>
                      Remove any copyright or other proprietary notations from
                      the materials
                    </li>
                  </ul>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">3. Product Information</h2>
                <div className="section__content">
                  <p className="section__text">
                    We strive to provide accurate product information, including
                    descriptions, prices, and availability. However, we do not
                    warrant that product descriptions or other content is
                    accurate, complete, reliable, current, or error-free.
                  </p>
                  <p className="section__text">
                    All prices are subject to change without notice. We reserve
                    the right to modify or discontinue any product at any time
                    without notice.
                  </p>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">4. Orders and Payment</h2>
                <div className="section__content">
                  <p className="section__text">
                    By placing an order, you warrant that you are legally
                    capable of entering into binding contracts and are at least
                    18 years of age. All orders are subject to acceptance and
                    availability.
                  </p>
                  <p className="section__text">
                    Payment must be received before goods are dispatched. We
                    accept major credit cards, PayPal, and other payment methods
                    as displayed during checkout.
                  </p>
                  <p className="section__text">
                    We reserve the right to refuse or cancel any order for any
                    reason, including but not limited to product availability,
                    errors in product or pricing information, or problems
                    identified by our credit and fraud departments.
                  </p>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">5. Shipping and Delivery</h2>
                <div className="section__content">
                  <p className="section__text">
                    We offer shipping within Australia and internationally.
                    Shipping costs and delivery times vary depending on the
                    destination and shipping method selected.
                  </p>
                  <p className="section__text">
                    Free shipping is available for Australian orders over $249.
                    Standard shipping rates apply to orders under this
                    threshold.
                  </p>
                  <p className="section__text">
                    Delivery times are estimates only and may be affected by
                    factors beyond our control. We are not liable for any delays
                    in delivery.
                  </p>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">6. Returns and Refunds</h2>
                <div className="section__content">
                  <p className="section__text">
                    We want you to be completely satisfied with your purchase.
                    If you are not satisfied, you may return items within 30
                    days of delivery for a full refund, subject to our returns
                    policy.
                  </p>
                  <p className="section__text">
                    Items must be returned in their original condition, unused
                    and in original packaging. Return shipping costs are the
                    responsibility of the customer unless the item was defective
                    or incorrectly shipped.
                  </p>
                  <p className="section__text">
                    For detailed information about returns and refunds, please
                    refer to our Returns Policy page.
                  </p>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">7. Privacy Policy</h2>
                <div className="section__content">
                  <p className="section__text">
                    Your privacy is important to us. Our Privacy Policy explains
                    how we collect, use, and protect your information when you
                    use our service. By using our service, you agree to the
                    collection and use of information in accordance with our
                    Privacy Policy.
                  </p>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">8. Limitation of Liability</h2>
                <div className="section__content">
                  <p className="section__text">
                    In no event shall Emeline Publications or its suppliers be
                    liable for any damages (including, without limitation,
                    damages for loss of data or profit, or due to business
                    interruption) arising out of the use or inability to use the
                    materials on our website.
                  </p>
                  <p className="section__text">
                    Our total liability to you for all damages, losses, and
                    causes of action shall not exceed the amount paid by you, if
                    any, for accessing our website or purchasing our products.
                  </p>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">9. Governing Law</h2>
                <div className="section__content">
                  <p className="section__text">
                    These terms and conditions are governed by and construed in
                    accordance with the laws of New South Wales, Australia, and
                    you irrevocably submit to the exclusive jurisdiction of the
                    courts in that state or location.
                  </p>
                </div>
              </section>

              <section className="terms__section">
                <h2 className="section__title">10. Contact Information</h2>
                <div className="section__content">
                  <p className="section__text">
                    If you have any questions about these Terms and Conditions,
                    please contact us:
                  </p>
                  <div className="contact__details">
                    <p>
                      <strong>Emeline Publications Australia</strong>
                    </p>
                    <p>6107 Katherine Rd, Rex, Georgia 30273, United States</p>
                    <p>Business Hours: Monday - Friday, 9:30am to 4:00pm</p>
                  </div>
                </div>
              </section>
            </div>

            {/* 相关链接 */}
            <section className="terms__links">
              <h2 className="section__title">Related Policies</h2>
              <div className="policy__links">
                <Link to="/privacy" onClick={toTop} className="policy__link">
                  Privacy Policy
                </Link>
                <Link to="/returns" onClick={toTop} className="policy__link">
                  Returns Policy
                </Link>
                <Link to="/delivery" onClick={toTop} className="policy__link">
                  Delivery Information
                </Link>
                <Link to="/contact" onClick={toTop} className="policy__link">
                  Contact Us
                </Link>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Terms;
